import { errorHelpers } from '@approvalmax/utils';

export const clearLocalStorageValue = (key: string) => {
    try {
        localStorage.removeItem(key);
    } catch (error) {
        errorHelpers.captureException(error);
    }
};
